var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popover',{staticClass:"dropdown--wrapper",style:(_vm.styles ? _vm.styles : {}),attrs:{"name":_vm.name,"width":_vm.width}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }